module.exports = __webpack_public_path__ + "img/GS_Profile-Nkululeko Nkabinde.e64e8a76.png";